import { Flex } from "@gravity-ui/uikit";
import { useGravityDevice } from "src/hooks";
import { useTranslate } from "src/i18n";
import { RatesWidget } from "src/widgets";

import { TextSection } from "../TextSection";

export const RatesBlock = () => {
  const { isMobile } = useGravityDevice();
  const { t } = useTranslate();

  return (
    <Flex
      id="rates"
      direction={"column"}
      width={"100%"}
      maxWidth={"1440px"}
      style={{
        paddingLeft: isMobile ? 30 : 50,
        paddingRight: isMobile ? 30 : 50,
        gap: 60,
      }}
    >
      <TextSection
        title={t("landing.rates_block.title", "Тарифные планы")}
        description={t(
          "landing.rates_block.description",
          "Информация и цены, на доступные тарифные планы",
        )}
      />

      <RatesWidget isLanding />
    </Flex>
  );
};
